import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Form from 'flarum/common/components/Form';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
export default class RenamePasskeyModal extends FormModal {
  constructor() {
    super(...arguments);
    // Streams must be created in oninit, not as class field initializers,
    // because Mithril sets `this.attrs` only after construction. A field
    // initializer on `this.attrs.passkey` runs first and throws.
    _defineProperty(this, "name", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.name = Stream(this.attrs.passkey.deviceName());
  }
  className() {
    return 'RenamePasskeyModal Modal--small';
  }
  title() {
    return app.translator.trans('datlechin-passkey.forum.settings.rename_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.fields().toArray()));
  }
  fields() {
    const fields = new ItemList();
    fields.add('name', m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      bidi: this.name,
      maxlength: 64,
      disabled: this.loading,
      autofocus: true
    })), 30);
    fields.add('submit', m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('datlechin-passkey.forum.settings.rename_modal.save_button'))), -10);
    return fields;
  }
  onsubmit(e) {
    var _this$name;
    e.preventDefault();
    const trimmed = ((_this$name = this.name()) != null ? _this$name : '').trim();
    if (trimmed === '') return;
    this.loading = true;
    this.attrs.passkey.save({
      deviceName: trimmed
    }).then(() => {
      var _this$attrs$onSuccess, _this$attrs;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('datlechin-passkey.forum.settings.alerts.rename_succeeded'));
      (_this$attrs$onSuccess = (_this$attrs = this.attrs).onSuccess) == null || _this$attrs$onSuccess.call(_this$attrs);
      this.hide();
    }).catch(() => {
      this.loaded();
    });
  }
}
flarum.reg.add('datlechin-passkey', 'forum/components/RenamePasskeyModal', RenamePasskeyModal);